import { useEffect, useRef } from "react";

export const useLongPressMenu = (onOpen, delay = 550) => {
  const callbackRef = useRef(onOpen);
  const pressRef = useRef(null);
  const suppressClickRef = useRef(false);
  const suppressTimerRef = useRef(null);
  callbackRef.current = onOpen;

  const clearPress = () => {
    const press = pressRef.current;
    if (!press) return;
    clearTimeout(press.timer);
    window.removeEventListener("pointermove", press.move);
    window.removeEventListener("pointerup", press.end);
    window.removeEventListener("pointercancel", press.end);
    pressRef.current = null;
  };

  useEffect(() => () => {
    clearPress();
    clearTimeout(suppressTimerRef.current);
  }, []);

  const start = (event, item) => {
    if (event.pointerType === "mouse") return;
    clearPress();
    const point = { clientX: event.clientX, clientY: event.clientY };
    const move = (nextEvent) => {
      if (Math.hypot(nextEvent.clientX - point.clientX, nextEvent.clientY - point.clientY) > 10) {
        clearPress();
      }
    };
    const end = () => clearPress();
    const timer = window.setTimeout(() => {
      clearPress();
      suppressClickRef.current = true;
      clearTimeout(suppressTimerRef.current);
      suppressTimerRef.current = window.setTimeout(() => { suppressClickRef.current = false; }, 900);
      navigator.vibrate?.(12);
      callbackRef.current(point, item);
    }, delay);
    pressRef.current = { timer, move, end };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", end);
    window.addEventListener("pointercancel", end);
  };

  const consumeClick = (event) => {
    if (!suppressClickRef.current) return false;
    event.preventDefault();
    event.stopPropagation();
    suppressClickRef.current = false;
    clearTimeout(suppressTimerRef.current);
    return true;
  };

  return { start, consumeClick };
};